// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jw9Fo","container":"styles_container__tpuov"};